import React from 'react';

interface PlanFindErrorProps {
  error: string;
}

const PlanFindError: React.FC<PlanFindErrorProps> = ({ error }) => {
    return (
      <div className="p-4 my-4 text-red-800 border border-red-300 rounded-lg bg-red-50" role="alert">
        <div className="flex items-center">
          <svg className="flex-shrink-0 w-4 h-4 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
          </svg>
          <h3 className="text-lg font-medium">Oh snap!!!</h3>
        </div>
        <div className="my-2 text-sm">
          {error}
        </div>
      </div>
    );
  };

export default PlanFindError;
